import { render } from "./Testimonial6Page.vue?vue&type=template&id=e36f2df4&scoped=true&ts=true"
import script from "./Testimonial6Page.vue?vue&type=script&lang=ts"
export * from "./Testimonial6Page.vue?vue&type=script&lang=ts"

import "./Testimonial6Page.vue?vue&type=style&index=0&id=e36f2df4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e36f2df4"]])

export default __exports__